import qs from 'qs';
import Cookies from 'js-cookie';
import { getSessionItem } from '@services/api/src/Domains/Enviroments/EnvironmentsService';
import { USER_ACCESS_COOKIE } from '../constants/constants';

const APPS = {
  endosso: 'PLATAFORMA_ENDOSSO',
  tomador: 'PLATAFORMA_TOMADOR',
  ajuda: 'PLATAFORMA_AJUDA',
  emissao: 'PLATAFORMA_URL',
  extrato: 'PLATAFORMA_EXTRATO',
  escalada: 'PLATAFORMA_ESCALADA',
  minhaconta: 'PLATAFORMA_MINHA_CONTA',
  processos: 'PLATAFORMA_PROCESSOS',
  listaProcessos: 'PLATAFORMA_PROCESSOS_LISTA',
  fidelize: 'PLATAFORMA_FIDELIZE',
  dashboard: 'PLATAFORMA_PAINEL',
  boletos: 'PLATAFORMA_BOLETOS',
  relatorios: 'PLATAFORMA_RELATORIOS',
  locaticia: 'PLATAFORMA_LEASE',
  locaticiaV2: 'PLATAFORMA_LEASE_V2',
  express: 'PLATAFORMA_EXPRESS',
  login: process.env.REACT_APP_PLATAFORMA_LOGIN,
};

export const redirectWithToken = (redirectUrl, queryParams = {}) => {
  const { token, expiresIn, broker } = Cookies.getJSON(USER_ACCESS_COOKIE);
  const user = localStorage.getItem('username');

  if (!broker || !token || !expiresIn || !user) {
    window.location = process.env.REACT_APP_PLATAFORMA_LOGIN;
  } else {
    const stringFieldParams = qs.stringify(
      { ...queryParams },
      { addQueryPrefix: true }
    );
    window.location = `${redirectUrl}${stringFieldParams}`;
  }
};

export const redirectToApp = (app = null, page = null, params = null) => {
  let url = app !== 'login' ? `${getSessionItem(APPS[app])}` : APPS[app];

  if (!url) return;

  if (page) url += page;

  redirectWithToken(url, params);
};
